var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2398_732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9145 7.90165e-05H2.08566C0.935776 7.90165e-05 9.42467e-05 0.926919 9.42467e-05 2.06594V11.9342C9.42467e-05 13.0732 0.935776 14.0001 2.08566 14.0001H6.28461V9.11741H4.61615V6.63838H6.28461V4.95814C6.28461 3.59113 7.40723 2.47911 8.78729 2.47911H11.3178V4.95814H8.78729V6.63838H11.3178L10.9007 9.11741H8.78729V14.0001H11.9145C13.0644 14.0001 14.0001 13.0732 14.0001 11.9342V2.06594C14.0001 0.926919 13.0644 7.90165e-05 11.9145 7.90165e-05Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2398_732"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.b3eeedf0596dd5a7dbe065bed7695a50.svg";
export { ForwardRef as ReactComponent };